// RIVELAZIONE ALLO SCORRIMENTO — un solo componente per tutte le entrate in scena.
// Non usa framer-motion per non montare un motore di animazione per ogni riga di testo:
// un IntersectionObserver aggiunge una classe, il resto lo fa il CSS.
import React, { useEffect, useRef, useState } from "react";

export default function Reveal({ children, delay = 0, y = 22, as: Tag = "div", className = "", once = true, style, ...rest }) {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) { setSeen(true); return; }
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setSeen(true); if (once) io.disconnect(); }
      else if (!once) setSeen(false);
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });
    io.observe(el);
    return () => io.disconnect();
  }, [once]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        ...(style || {}),
        opacity: seen ? 1 : 0,
        transform: seen ? "none" : `translate3d(0,${y}px,0)`,
        transition: `opacity .7s cubic-bezier(.16,1,.3,1) ${delay}ms, transform .7s cubic-bezier(.16,1,.3,1) ${delay}ms`,
        willChange: "opacity, transform",
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
